import { showSuccessNotification } from 'modules/notification/notification$';
import { collectRoutines, dispatchAction, routine } from 'rxbeach';
import { extractPayload, ofType } from 'rxbeach/operators';
import { filter, switchMap, tap } from 'rxjs/operators';
import { catcher } from 'streams/catcher';
import {
  AuthResponse,
  apiForgot,
  apiLogin,
  apiMe,
  apiRegister,
  apiReset,
} from '../apiService';
import {
  authError,
  authSuccess,
  authenticate,
  forgot,
  login,
  logout,
  register,
  reset,
} from './actions';

const errorHandler = (error: any) => dispatchAction(authError(error));

const handleLogin = routine(
  ofType(login),
  extractPayload(),
  switchMap(apiLogin),
  tap(({ user, token }) => dispatchAction(authSuccess({ user, token }))),
  tap(({ token }) => window.localStorage.setItem('jwt', token)),
  catcher(errorHandler)
);

const handleRegister = routine(
  ofType(register),
  extractPayload(),
  switchMap(apiRegister),
  tap(({ user, token }) => dispatchAction(authSuccess({ user, token }))),
  tap(({ token }) => window.localStorage.setItem('jwt', token)),
  catcher(errorHandler)
);

const handleForgot = routine(
  ofType(forgot),
  extractPayload(),
  switchMap(apiForgot),
  catcher(errorHandler)
);

const handleReset = routine(
  ofType(reset),
  extractPayload(),
  switchMap(apiReset),
  tap(({ user, token }) => dispatchAction(authSuccess({ user, token }))),
  tap(({ token }) => window.localStorage.setItem('jwt', token)),
  catcher(errorHandler)
);

const authenticateRoutine = routine(
  ofType(authenticate),
  switchMap(apiMe),
  filter((response): response is AuthResponse => !!response),
  tap(({ user }) => dispatchAction(authSuccess({ user }))),
  catcher(errorHandler)
);

const handleAuthSuccess = routine(
  ofType(authSuccess),
  extractPayload(),
  tap(({ user }) => {
    dispatchAction(
      showSuccessNotification(`Velkommen ${user.name} 🐶 Du er nå logget inn`)
    );
  })
);

const handleLogout = routine(
  ofType(logout),
  tap(() => {
    window.localStorage.setItem('jwt', '');
  })
);

export default collectRoutines(
  handleLogin,
  handleRegister,
  handleLogout,
  handleForgot,
  handleReset,
  authenticateRoutine,
  handleAuthSuccess
);
